import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LocationSelector from '../LocationSelector';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import { faLess } from '@fortawesome/free-brands-svg-icons';
import FaView from '../FaView';
import ActivityLog from '../ActivityLog';


const displayNone = {
    display: "none"
}

function Tran_glvtm_settlement() {
    const surrType = "'VR','OPNEVTM'";
    const settleType = "'VT', 'OPNVTMST'";
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const sid = sessionStorage.getItem("sessionId");
    const branchDisable = sessionStorage.getItem('branchDisable');
    const navigate = useNavigate();

    const [radioType, setRadioType] = useState("N");
    const [userRight, setUserRight] = useState([]);

    const [showGvtModal, setShowGvtModal] = useState(false);

    const [counter, setCounter] = useState(0);
    const [key, setKey] = useState("INFO");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [hdrDate, setHdrDate] = useState("");
    const [scrMode, setScrMode] = useState("");
    const [vtLocationValue, setVTLocationValue] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");
    const [gtvList, setGvtList] = useState([]);

    const [stLocation, setSTLocation] = useState(null);
    const [stNewDate, setSTNewDate] = useState(new Date());
    const [stFromDate, setSTFromDate] = useState(new Date());
    const [stSrnoFrom, setSTSrnoFrom] = useState("");
    const [stSrnoTo, setSTSrnoTo] = useState("");
    const [stToDate, setSTToDate] = useState(new Date());
    const [stIssuer, setSTIssuer] = useState(null);
    const [stBank, setSTBank] = useState(null);
    const [stSaleType, setSTSaleType] = useState("N")
    const [hdrSrno, setHdrSrno] = useState(0);
    const [stLocationValue, setSTLocationValue] = useState("");

    const [nTTDate, setNTTDate] = useState(null);
    const [nTTValue, setNTTValue] = useState("");
    const [nManualNo, setNManualno] = useState(null);
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");

    const [branchRadio, setBranchRadio] = useState("A");
    const [pLocation, setPLocation] = useState(null);
    const [pRefNo, setPRefNo] = useState(null);
    const [pRate, setPRate] = useState("");
    const [pValue, setPValue] = useState("");
    const [pOptions, setPOptions] = useState("SELECTIVE");
    const [pVtm, setPVtm] = useState(null);
    const [pIsdId, setPIsdId] = useState("");
    const [pIssuerAccount, setPIssuerAccount] = useState("");
    const [pIssuerGroup, setPIssuerGroup] = useState("");
    const [pIsd, setPIsd] = useState(null);
    const [pIssuer, setPIssuer] = useState(null);
    const [pSelectedLocations, setPSelectedLocations] = useState([]);
    const [pLocRadio, setPLocRadio] = useState("");
    const [pIssuerName, setPIssuerName] = useState("");
    const [settlementList, setSettlementList] = useState([]);
    const [selectiveVTList, setSelectiveVTList] = useState([]);
    const [maxSettleLineNo, setMaxSettleLineNo] = useState(1);

    const [evtLocationValue, setEVTLocationValue] = useState("");
    const [surSelectedLocations, setSurSelectedLocations] = useState([]);
    const [surRefNo, setSurRefNo] = useState(null);
    const [surLocRadio, setSurLocRadio] = useState("");

    const [surIsd, setSurIsd] = useState(null);
    const [surIsdId, setSurIsdId] = useState("");
    const [surOptions, setSurOptions] = useState("SELECTIVE");

    const [surRate, setSurRate] = useState("");
    const [surValue, setSurValue] = useState("");
    const [surSelectiveEVTList, setSurSelectiveEVTList] = useState([]);

    const [surrenderList, setSurrenderList] = useState([]);
    const [maxSurrenderLineNo, setMaxSurrenderLineNo] = useState(1);

    const [totalSettlement, setTotalSettlement] = useState(0);
    const [totalSurrender, setTotalSurrender] = useState(0);

    const [pdBankRefNo, setPdBankRefNo] = useState("");
    const [paymentData, setPaymentData] = useState([]);

    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });

    const [totalValueSettl, setTotalValueSettl] = useState(0);
    const [totalValueSurr, setTotalValueSurr] = useState(0);
    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);





    useEffect(() => {
        const hoLocation = { "id": "^1001^HO^", "label": "1001 HO" };
        handleLocationChange(hoLocation);
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_GL_SETTLEMENT_VTM'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
    }, []);

    const handleManualNo = (value) => setNManualno(value);

    const handleLocationChange = (value) => {
        setSTLocation(value);
        var id = value.id;
        var location = id.split("^");
        setSTLocationValue(location[1]);
        setHdrLocation(location[2]);
    }

    const handleChangeIsd = (value) => {
        let a;
        if (key == 'SETTLEMENT') {
            setPIsd(value);
            a = value.id.split("^");
            setPIsdId(a[1]);
        } else if (key == 'SURRENDER') {
            setSurIsd(value);
            a = value.id.split("^");
            setSurIsdId(a[1]);
        }
    }

    const handleTabChange = (k) => {
        setKey(k);
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            //vtmR.current.focus();
        }
    }

    const handleOptions = (v) => {
        if (key == 'SETTLEMENT') {
            setPOptions(v);
            setPRefNo(null);
            setPRate("");
            setPValue("");
            setSelectiveVTList([]);
        } else if (key == 'SURRENDER') {
            setSurOptions(v);
            setSurRefNo(null);
            setSurRate("");
            setSurValue("");
            setSurSelectiveEVTList([]);
        }
    }

    const handleRefChange = (value) => {
        var a;
        if (key == 'SETTLEMENT') {
            setPRefNo(value);
            a = value.id.split("^");
            setPValue(a[4]);
        } else if (key == 'SURRENDER') {
            setSurRefNo(value);
            a = value.id.split("^");
            setSurValue(a[4]);
        }

    }

    const handleIssuerChange = value => {
        setSTIssuer(value);
        setPIssuer(value);
        var a = value.id.split("^");
        setPIssuerGroup(a[1]);
        setPIssuerAccount(a[2]);
        setPIssuerName(a[5]);
    }

    const addNewForm = () => {
        var d = Common.dateYMD(stNewDate);
        var ddmy = Common.dateDMY(stNewDate);
        setHdrDate(ddmy);
        var today = Common.dateYMD(new Date());
        var msg = []; var i = 0;
        if (stLocation == null || pIssuer === null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (stLocation == null ? "Location." : '');
            msg[i++] = (pIssuer === null ? "Issuer." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else {
            setScrMode("A");
            setHdrSrno(0);
            setSelectiveVTList([]);
            setSettlementList([]);
            setSurrenderList([]);
            setNManualno(null);
            setNTTDate(null);
            setNTTValue("");
            setNRemark1("");
            setNRemark2("");
            setPIsd(null);
            setPRate("");
            setPValue("");
            setPRefNo(null);
            var a = pIssuer.id.split("^");
            setPIssuerGroup(a[1]);
            setPIssuerAccount(a[2]);
            setPIssuerName(a[5]);
            setPdBankRefNo("");
            setTotalSettlement(0);
            setTotalSurrender(0);
            setTotalValueSettl(0);
            setTotalValueSurr(0);
            setPaymentData([]);
            setNRemark1('')
            setNRemark2('')
        }
    };

    const activityHandler = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "GVT", trannumber: hdrSrno, trancategory: "T", location: stLocationValue });
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const addSettlementProduct = (type) => {
        var i = 0, msg = [];
        if (pIsd === null || stIssuer === null || pRate === "" || pRate === 0
            || (pOptions === "SEARCH" && pRefNo === null)
            || (pOptions === "FIFO" && pValue === "")
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? "Currency" : '');
            msg[i++] = (stIssuer === null ? "Issuer" : '');
            msg[i++] = (pRate === "" || pRate === 0 ? "Rate can't be zero or null" : '');
            msg[i++] = (pOptions === "SEARCH" && pRefNo === null ? "Reference Number" : '');
            msg[i++] = (pOptions === "FIFO" && pValue === "" ? "Value" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var issuer = pIssuer.id.split("^");
            const obj = {
                isd: pIsdId,
                group: pIssuerGroup,
                account: pIssuerAccount,
                location: pLocRadio === "S" ? pSelectedLocations : pLocRadio === "A" ? 0 : vtLocationValue,
                type: "'VT', 'OPNVTMST'",
                date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(stNewDate)
            }
            if (pOptions === "FIFO" || pOptions === "SELECTIVE") {
                var totalvalue = pValue * 1;
                var selectivevtList = [];
                var settlement_fifo_list = [];
                Common.callApi(Common.apiGVTSettlement, [sid, "fifovtlist", JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    let gvtsettled = false;
                    let count = 0;
                    let msg = "";
                    for (var i = 0; i < resp.length; i++) {
                        resp[i].sale_rate = resp[i].prd_rate;
                        resp[i].prd_rate = pRate;
                        resp[i].prd_amount = Number(resp[i].prd_deno * pRate).toFixed(2);
                        resp[i].prd_account = pIssuerAccount;
                        resp[i].prd_group = pIssuerGroup;
                        resp[i].prd_deno = 1 * resp[i].prd_deno;
                        resp[i].mvli_ledger_name = issuer[5];
                        resp[i].uniquekey = Common.getRandomString();
                        //resp[i].prd_location = resp[i].ho_locaiton;

                        if (isProductAlreadyAdded(resp[i])) {
                            gvtsettled = false;
                            continue;
                        }
                        if (pOptions === "FIFO") {
                            if (totalvalue < 0) break;
                            if (totalvalue >= resp[i].prd_deno) {
                                gvtsettled = true;
                                count++;
                                settlement_fifo_list = Common.arrayAddItem(settlementList, resp[i]);
                                setSettlementList(settlement_fifo_list);
                                totalvalue = totalvalue - resp[i].prd_deno * 1;
                            }
                        } else {
                            gvtsettled = true;
                            count++;
                            selectivevtList = Common.arrayAddItem(selectivevtList, resp[i]);
                            setShowGvtModal(true);
                        }
                    }
                    setSelectiveVTList(selectivevtList);
                    if (settlement_fifo_list.length > 0) calculateTotalSettlement(settlement_fifo_list);
                    if (!gvtsettled && count == 0) {
                        setMsgBox(true);
                        setMsgText("VTM not available for settlement");
                    }
                });
            } else {
                var ref = pRefNo.id.split("^");
                const obj1 = {
                    uniquekey: Common.getRandomString(),
                    prd_type: ref[8],
                    prd_isd: pIsdId,
                    prd_line_no: ref[1],
                    prd_location: ref[2],
                    prd_srno: ref[3],
                    prd_deno: ref[4],
                    prd_card_no: ref[9],
                    prd_amount: Number(pRate * ref[4]).toFixed(2),
                    prd_from: ref[5],
                    entity_name: ref[6],
                    mvli_ledger_name: issuer[5],
                    prd_account: pIssuerAccount,
                    prd_group: pIssuerGroup,
                    prd_rate: pRate,
                    prd_qty: 1,
                    delny: "Y"
                }
                if (!isProductAlreadyAdded(obj1)) {
                    const settlelist = Common.arrayAddItem(settlementList, obj1);
                    setSettlementList(settlelist);
                    calculateTotalSettlement(settlelist);
                    //audit trail obj
                    if (userRight.edit === "1" && scrMode === 'E') {
                        const obj2 = {
                            TabType: "settlementList",
                            ALineNo: tranAuditTrail.length + 1,
                            AType: "A",
                            TLoc: 1001,
                            TType: 'GVT',
                            ...obj1
                        }
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                    }
                } else {
                    setMsgBox(true);
                    setMsgText("VTM already added.");
                }
            }
            setCounter(counter + 1);
            setPRefNo(null);
            setPRate("");
            setPValue("");
        }
    };

    const addSurProduct = (type) => {
        var i = 0, msg = [];
        if (surIsd === null || stIssuer === null || surRate === "" || surRate === 0
            || (surOptions === "SEARCH" && surRefNo === null)
            || (surOptions === "FIFO" && surValue === "")
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (surIsd === null ? "Currency" : '');
            msg[i++] = (stIssuer === null ? "Issuer" : '');
            msg[i++] = (surRate === "" || surRate === 0 ? "Rate can't be zero or null" : '');
            msg[i++] = (surOptions === "SEARCH" && surRefNo === null ? "Reference Number" : '');
            msg[i++] = (surOptions === "FIFO" && surRefNo === "" ? "Value" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var issuer = pIssuer.id.split("^");
            const obj = {
                isd: surIsdId,
                group: pIssuerGroup,
                account: pIssuerAccount,
                location: surLocRadio === "S" ? surSelectedLocations : surLocRadio === "A" ? 0 : evtLocationValue,
                type: surrType,
                date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(stNewDate)
            }
            if (surOptions === "FIFO" || surOptions === "SELECTIVE") {
                var selectivevtList = [];
                var surr_fifo_list = [];
                var totalvalue = surValue * 1;
                Common.callApi(Common.apiGVTSettlement, [sid, "fifovtlist", JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    let gvtsettled = false;
                    let count = 0;
                    for (var i = 0; i < resp.length; i++) {
                        resp[i].sale_rate = resp[i].prd_rate;
                        resp[i].prd_rate = surRate;
                        resp[i].prd_amount = Number(resp[i].prd_deno * surRate).toFixed(2);
                        resp[i].prd_account = pIssuerAccount;
                        resp[i].prd_group = pIssuerGroup;
                        resp[i].prd_deno = 1 * resp[i].prd_deno;
                        resp[i].mvli_ledger_name = issuer[5];
                        resp[i].uniquekey = Common.getRandomString();
                        //resp[i].prd_location = resp[i].ho_locaiton;

                        if (isProductAlreadyAdded(resp[i])) continue;
                        if (surOptions === "FIFO") {
                            if (totalvalue < 0) break;
                            if (1 * totalvalue >= resp[i].prd_deno * 1) {
                                count++;
                                gvtsettled = true;
                                surr_fifo_list = Common.arrayAddItem(surrenderList, resp[i]);
                                setSurrenderList(surr_fifo_list);
                                totalvalue = totalvalue - resp[i].prd_deno * 1;
                            }
                        } else {
                            gvtsettled = true;
                            count++;
                            selectivevtList = Common.arrayAddItem(selectivevtList, resp[i]);
                            setShowGvtModal(true);
                        }
                    }
                    setSelectiveVTList(selectivevtList);
                    if (surr_fifo_list.length > 0) calculateTotalSurrender(surr_fifo_list);
                    if (!gvtsettled && count == 0) {
                        setMsgBox(true);
                        setMsgText("EVTM not available for settlement");
                    }
                });
            } else {
                var ref = surRefNo.id.split("^");
                const obj1 = {
                    uniquekey: Common.getRandomString(),
                    prd_type: ref[8],
                    prd_isd: surIsdId,
                    prd_line_no: ref[1],
                    prd_location: ref[2],
                    prd_srno: ref[3],
                    prd_deno: ref[4],
                    prd_card_no: ref[9],
                    prd_amount: Number(surRate * ref[4]).toFixed(2),
                    prd_from: ref[5],
                    entity_name: ref[6],
                    mvli_ledger_name: issuer[5],
                    prd_account: pIssuerAccount,
                    prd_group: pIssuerGroup,
                    prd_rate: surRate,
                    prd_qty: 1,
                    delny: "Y"
                }
                if (!isProductAlreadyAdded(obj1)) {
                    const surrlist = Common.arrayAddItem(surrenderList, obj1);
                    calculateTotalSurrender(surrlist);
                    setSurrenderList(surrlist);
                }
                else {
                    setMsgBox(true);
                    setMsgText("EVTM already added.");
                }
            }
            setCounter(counter + 1);
            setSurRefNo(null);
            setSurRate("");
            setSurValue("");
            setSurIsd("");
        }
    };

    const calculateTotalSettlement = (list) => {
        // if (list.length < 1) return;
        let totalAmt = 0;
        let totalvalue = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            totalAmt = totalAmt + list[i].prd_amount * 1;
            totalvalue = totalvalue + list[i].prd_deno * 1;
        }
        setTotalSettlement(Number(totalAmt).toFixed(2));
        setTotalValueSettl(Number(totalvalue).toFixed(2));
    }

    const calculateTotalSurrender = (list) => {
        // if (list.length < 1) return;
        let totalAmt = 0;
        let totalvalue = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            totalAmt = totalAmt + list[i].prd_amount * 1;
            totalvalue = totalvalue + list[i].prd_deno * 1;
        }
        setTotalSurrender(Number(totalAmt).toFixed(2));
        setTotalValueSurr(Number(totalvalue).toFixed(2));
    }

    function isProductAlreadyAdded(obj) {
        if (key === "SETTLEMENT")
            return settlementList.some(row =>
                row.prd_srno === obj.prd_srno &&
                row.prd_line_no === obj.prd_line_no &&
                row.prd_type === obj.prd_type &&
                row.prd_location === obj.prd_location
            );
        else
            return surrenderList.some(row =>
                row.prd_srno === obj.prd_srno &&
                row.prd_line_no === obj.prd_line_no &&
                row.prd_type === obj.prd_type &&
                row.prd_location === obj.prd_location
            );
    }

    const deleteProduct = (value, index) => {
        let gvtlist;
        if (key == 'SETTLEMENT') {
            const removedItem = settlementList[index];
            gvtlist = Common.arrayRemoveItem(settlementList, "uniquekey", value);
            setSettlementList(gvtlist);
            calculateTotalSettlement(gvtlist);
            setCounter(counter - 1);
            //audit trail obj
            const obj2 = {
                TabType: "settlementList",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: 1001,
                TType: 'GVT',
                ...removedItem
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
        } else if (key == 'SURRENDER') {
            const removedItem = settlementList[index];
            gvtlist = Common.arrayRemoveItem(surrenderList, "uniquekey", value);
            calculateTotalSurrender(gvtlist);
            setSurrenderList(gvtlist);
            setCounter(counter - 1);
            //audit trail obj
            const obj2 = {
                TabType: "surrenderList",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: 1001,
                TType: 'GVT',
                ...removedItem
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
        }
    }

    const editData = () => {
        setScrMode("E");
    };

    const listGVTdata = () => {
        var msg = [], i = 0;
        $(".loader").show();
        if (stLocation === null || (radioType === 'S' && !stSrnoFrom) || (radioType === 'S' && !stSrnoTo) || (radioType === 'D' && !stFromDate) ||
            (radioType === 'D' && !stToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (stLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !stSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !stSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !stFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !stToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: stLocationValue,
                type: "GVT",
                radioType: radioType,
                stSrnoTo: stSrnoTo,
                stSrnoFrom: stSrnoFrom,
                stToDate: Common.dateYMD(stToDate),
                stFromDate: Common.dateYMD(stFromDate)
            }
            Common.callApi(Common.apiGVTSettlement, [sid, "listdata", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setGvtList(JSON.parse(result));
            });
        }
    };

    const fillViewForm = (hdrsrno, location, type, date, dateymd) => {
        $(".loader").show();
        setHdrDate(date);
        setHdrSrno(hdrsrno);
        setKey("INFO");
        setScrMode('Q');
        setHdrDateYmd(dateymd);
        const obj = {
            srno: hdrsrno,
            location: location,
            type: type
        }
        Common.callApi(Common.apiGVTSettlement, [sid, "viewdata", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            setHdrLocation(resp.locname);
            setScrMode("Q");
            setSTIssuer({ id: resp.issid, label: resp.isslabel });
            setPIssuer({ id: resp.issid, label: resp.isslabel });
            setSettlementList(resp.sattlementlist);
            setMaxSettleLineNo(resp.maxline);
            setSurrenderList(resp.surrenderlist);
            setMaxSurrenderLineNo(resp.maxlineevtm);
            setPIssuerGroup(resp.grp);
            setPIssuerAccount(resp.acct);
            setPIssuerName(resp.accname);
            setTotalSettlement(Number(resp.total_settlement).toFixed(2));
            setTotalSurrender(Number(resp.total_surrender).toFixed(2));
            setPaymentData(resp.paymentdata);
            calculateTotalSurrender(resp.surrenderlist);
            calculateTotalSettlement(resp.sattlementlist);
            setNRemark1(resp.remark1);
            setNRemark2(resp.remark2);
        });
    }

    const fillViewCompareObject = (resp) => {
        const obj2 = {
            type: "GVT",
            srno: resp.srno,
            location: resp.locname,
            stIssuer: { id: resp.issid, label: resp.isslabel },
            stBank: stBank,
            stNewDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(stNewDate),
            stSaleType: stSaleType,
            nTTValue: nTTValue,
            nTTDate: Common.dateYMD(nTTDate),
            nManualNo: nManualNo,
            nRemark1: resp.remark1,
            nRemark2: resp.remark2,
            settlementList: resp.sattlementlist,
            surrenderList: resp.surrenderlist,
            totalSettlement: Number(resp.total_settlement).toFixed(2),
            totalSurrender: Number(resp.total_surrender).toFixed(2),
            pIssuerGroup: resp.grp,
            pIssuerAccount: resp.acct,

            radioType: radioType,
            stToDate: Common.dateYMD(stToDate),
            stFromDate: Common.dateYMD(stFromDate),
            stSrnoTo: stSrnoTo,
            stSrnoFrom: stSrnoFrom,
            paymentData: resp.paymentdata,
            totalValueSettl: Number(resp.total_settlement).toFixed(2),
            totalValueSurr: Number(resp.total_surrender).toFixed(2),
        };
        setCompareData([obj2]);
    }


    const saveData = () => {
        $(".loader").show();
        var i = 0, msg = [];
        msg[i++] = Common.getMessage("MSG0006");
        if (scrMode ==='A'){
            (surrenderList.length == 0) && (settlementList.length == 0) && (msg[i++] = "Either Select surrender and Settlement .");
        }
        if (i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        } else if (paymentData.length > 0) {
            const paymentAmt = paymentData.reduce((acc, item) => { return acc + item.tp_amount }, 0);
            console.log(paymentAmt);
            console.log(totalSettlement - totalSurrender);
            if (paymentAmt != (totalSettlement - totalSurrender)) {
                $(".loader").hide();
                setMsgBox(true);
                setMsgText("Payment amount should be equal to total difference.");
                return;
            }
        }
        // $(".loader").show();
        const obj1 = {
            type: "GVT",
            srno: hdrSrno,
            location: stLocationValue,
            stIssuer: stIssuer,
            stBank: stBank,
            stNewDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(stNewDate),
            stSaleType: stSaleType,
            nTTValue: nTTValue,
            nTTDate: Common.dateYMD(nTTDate),
            nManualNo: nManualNo,
            nRemark1: nRemark1,
            nRemark2: nRemark2,
            settlementList: settlementList,
            surrenderList: surrenderList,
            totalSettlement: totalSettlement,
            totalSurrender: totalSurrender,
            pIssuerGroup: pIssuerGroup,
            pIssuerAccount: pIssuerAccount,

            radioType: radioType,
            stToDate: Common.dateYMD(stToDate),
            stFromDate: Common.dateYMD(stFromDate),
            stSrnoTo: stSrnoTo,
            stSrnoFrom: stSrnoFrom,
            paymentData: paymentData,
            totalValueSettl: totalValueSettl,
            totalValueSurr: totalValueSurr,
        }
        const infoObject = Common.compareArrays(compareData, [obj1]);
        if (userRight.edit === "1" && scrMode === "E") {
            setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'GVT', stLocationValue));
        }
        Common.callApi(Common.apiGVTSettlement, [sid, "savedata", JSON.stringify(obj1), JSON.stringify(tranAuditTrail)], result => {
            let resp = JSON.parse(result);
            $(".loader").hide();
            setMsgBox(true);
            setMsgText(Common.getMessage(resp.msg));
            setScrMode("");
            setGvtList(resp.gvtdata);
            setTranAuditTrail([])
        });
    };


    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        if (key == 'SETTLEMENT') {
            setVTLocationValue(newLocationCode);
            setPSelectedLocations(newSelectedItems);
            setPRefNo(null);
            setPLocRadio(newRadioType);
        } else if (key == 'SURRENDER') {
            setEVTLocationValue(newLocationCode);
            setSurSelectedLocations(newSelectedItems);
            setSurRefNo(null);
            setSurLocRadio(newRadioType);
        }

    };

    const handlePIssuer = (value) => {
        setPIssuer(value);
        var a = value.id.split("^");
        setPIssuerGroup(a[1]);
        setPIssuerAccount(a[2]);
    }

    const updateSelectiveCheck = (e, index, name) => {
        const tempArr = selectiveVTList.map((item, i) => {
            if (index === i) {
                if (name === "ischecked") {
                    if (e.target.checked) return { ...item, [name]: "1" };
                    else return { ...item, [name]: "0" };
                }
            } else {
                return item;
            }
        });
        setSelectiveVTList(tempArr);
    }

    const updateAllCheck = (e, name) => {
        // console.log(selectiveVTList);
        const tempArr = selectiveVTList.map((item) => {
            if (name === "ischecked") {
                if (e.target.checked) return { ...item, [name]: "1" };
                else return { ...item, [name]: "0" };
            }
        });
        // console.log(tempArr);
        setSelectiveVTList([...tempArr]);
    }

    const addSelectiveGvt = () => {
        selectiveVTList.map(item => {
            if (item.ischecked === "1") {
                if (key == "SURRENDER") {
                    const surrList = Common.arrayAddItem(surrenderList, item);
                    setSurrenderList(surrList);
                    calculateTotalSurrender(surrList);
                    //audit trail obj
                    if (userRight.edit === "1" && scrMode === 'E') {
                        const obj2 = {
                            TabType: "surrenderList",
                            ALineNo: tranAuditTrail.length + 1,
                            AType: "A",
                            TLoc: 1001,
                            TType: 'GVT',
                            ...item
                        }
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                    }
                } else {
                    const settlelist = Common.arrayAddItem(settlementList, item);
                    calculateTotalSettlement(settlelist);
                    setSettlementList(settlelist);
                    //audit trail obj
                    if (userRight.edit === "1" && scrMode === 'E') {
                        const obj2 = {
                            TabType: "settlementList",
                            ALineNo: tranAuditTrail.length + 1,
                            AType: "A",
                            TLoc: 1001,
                            TType: 'GVT',
                            ...item
                        }
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                    }
                }
                setShowGvtModal(false);
            }
        });
    }

    const addPayment = () => {
        if (stBank === null) {
            setMsgBox(true);
            setMsgText("Please select bank.");
        }
        // else if ((totalSettlement - totalSurrender) < 0) {
        //     setMsgBox(true);
        //     setMsgText("Can't add payment when difference is -ve.");
        // } 
        else if (paymentData.length > 0) {
            setMsgBox(true);
            setMsgText("Can't add more than one payment.");
        } else {
            var bank = stBank.id.split("^");
            const obj = {
                tp_group: bank[1],
                tp_account: bank[2],
                tp_amount: totalSettlement - totalSurrender,
                tp_cheque: pdBankRefNo,
                mvli_ledger_name: bank[5],
                uniquekey: Common.getRandomString()
            }
            setPaymentData(Common.arrayAddItem(paymentData, obj));
            //audit trail obj
            const obj2 = {
                TabType: "paymentList",
                ALineNo: tranAuditTrail.length + 1,
                TLoc: 1001,
                AType: 'A',
                TType: 'GVT',
                ...obj,
                tp_line_no: 1,
                tp_srno: hdrSrno,
                tp_location: 1001,
                tp_type: 'GVT',
                tp_payment_type: 'BANK'
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
        }
        setSTBank(null);
        setPdBankRefNo("");
    }

    const deletePayment = (item) => {
        setPaymentData(Common.arrayRemoveItem(paymentData, "uniquekey", item.uniquekey));
        setCounter(counter + 1);
        //audit trail obj
        if (userRight.edit === "1" && scrMode === 'E') {
            const obj2 = {
                TabType: "paymentList",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: 1001,
                TType: 'GVT',
                ...item
            }
            setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
        }
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: stLocationValue, trannumber: hdrSrno, type: 'GVT' });
    }

    return (
        <div>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Global VTM Settlement</h2>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col style={{ display: "none" }} className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={stLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLocationChange}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <>
                                            <Row>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Date</Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={stNewDate}
                                                            onChange={(date) => setSTNewDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col style={{ display: "none" }} className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Sale Type</Form.Label>
                                                        <Form.Select value={stSaleType} onChange={e => setSTSaleType}>
                                                            <option value="N">Normal</option>
                                                            <option value="EEFCB">EEFC</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Issuer<span className='colorThemeRed'>*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={stIssuer}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', "0")} // location = 1 , 2
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleIssuerChange}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Bank<span className='colorThemeRed'>*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={stBank}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'BANK', "0")} // location = 1 , 2
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={(value) => setSTBank(value)}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col> */}
                                            </Row>
                                        </>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={stSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSTSrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={stSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setSTSrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={stFromDate}
                                                                onChange={(date) => setSTFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={stToDate}
                                                                onChange={(date) => setSTToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && radioType !== "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listGVTdata()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }

                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive bordered striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Sr No</th>
                                            <th>Type</th>
                                            <th>Account</th>
                                            <th>Total Settlement</th>
                                            <th>Total Surrender</th>
                                            <th>Difference</th>
                                            <th>Date</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            gtvList.map((item, index) => (
                                                <tr key={item.hdr_srno + '^' + item.hdr_location}>
                                                    <td>
                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.hdr_location, item.hdr_type, item.hdr_date, item.hdr_date_ymd)} className='pointer colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.hdr_srno}</td>
                                                    <td>{item.hdr_type}</td>
                                                    <td>{item.hdr_group} {item.hdr_ledger} {item.mvli_ledger_name}</td>
                                                    <td>{item.hdr_settlment_amount}</td>
                                                    <td>{item.hdr_surrender_amount}</td>
                                                    <td>{item.hdr_total_inr}</td>
                                                    <td>{item.hdr_date}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                editData()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ?
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => handleFaView()}>FA View</Button>
                                            : null
                                    }
                                    &nbsp;
                                    {
                                        (userRight.query === "1" && scrMode != "A") ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => activityHandler()}>Activity Log</Button> : null
                                    }
                                    {/*
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print("D")}>With Deno</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => print("")}>Without Deno</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>
                                        </> : null
                                    */}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-2'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2">
                                    <span>Location : <b>{hdrLocation}</b></span>
                                </Col>
                                {/* <Col className="col-md-2 col-4">
                                    <span>Srno. : <b>{hdrSrno}</b></span>
                                </Col> */}
                                <Col className="col-md-2">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className="col-md-3">
                                    <span>Issuer : <b>{pIssuerGroup + " " + pIssuerAccount + " " + pIssuerName}</b></span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-md-2">
                                    <span><b>Total Settlement: {totalSettlement}</b></span>
                                </Col>
                                <Col className="col-md-2">
                                    <span><b>Total Surrender: {totalSurrender}</b></span>
                                </Col>
                                <Col className="col-md-2">
                                    <span><b>Difference: {(totalSettlement - totalSurrender).toFixed(2)}</b></span>
                                </Col>
                                {/* <Col className='ppCharges'>
                                    <span><b>Total Settlement: {totalSettlement}</b></span>
                                    &nbsp;
                                    <span><b>Total Surrender: {totalSurrender}</b></span>
                                    &nbsp;
                                    <span><b>Difference: {(totalSettlement - totalSurrender).toFixed(2)}</b></span>
                                </Col> */}
                            </Row>
                            <Row>
                                <Col className="col-md-2">
                                    <span><b>Total Value Sett.: {totalValueSettl}</b></span>
                                </Col>
                                <Col className="col-md-2">
                                    <span><b>Total Value Surr.: {totalValueSurr}</b></span>
                                </Col>
                                <Col className="col-md-2">
                                    <span><b>Difference: {(totalValueSettl - totalValueSurr).toFixed(2)}</b></span>
                                </Col>
                                {/* <Col className='ppCharges'>

                                    <span><b>Total Value Sett.: {totalValueSettl}</b></span>
                                    &nbsp;
                                    <span><b>Total Value Surr.: {totalValueSurr}</b></span>
                                    &nbsp;
                                    <span><b>Difference: {(totalValueSettl - totalValueSurr).toFixed(2)}</b></span>
                                </Col> */}
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col style={{ display: "none" }} className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Type</Form.Label>
                                                <Form.Select value={stSaleType} onChange={e => setSTSaleType(e.target.value)} disabled>
                                                    <option value="N">Normal</option>
                                                    <option value="EEFBC">EEFBC</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Issuer<span className='colorThemeRed'>*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={stIssuer}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', vtLocationValue)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    isDisabled
                                                    onChange={(value) => setSTIssuer(value)}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Manual Number</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nManualNo}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchManualTypePicklist(search, stLocationValue, 'SP')} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleManualNo}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>TT Value</Form.Label>
                                                <Form.Control disabled={scrMode === "Q"} value={nTTValue} onChange={e => setNTTValue(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>TT Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nTTDate}
                                                    onChange={(date) => setNTTDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={scrMode === "Q"}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 1</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 2</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("SETTLEMENT")}>Product-&gt;</Button>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="SETTLEMENT" title="Settlement">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    {
                                        scrMode === "Q" ? null :
                                            <>
                                                <Row>
                                                    <Col className='col-md-6 col-12'>
                                                        <LocationSelector onDataFromChild={handleDataFromChild} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pIsd}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, "")} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleChangeIsd}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {/* <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Issuer<span className='colorThemeRed'>*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={pIssuer}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', vtLocationValue)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handlePIssuer}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col> */}
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Options</Form.Label>
                                                            <Form.Select value={pOptions} onChange={e => handleOptions(e.target.value)}>
                                                                <option value="SEARCH">Search</option>
                                                                {/* <option value="FIFO">FIFO</option> */}
                                                                <option value="SELECTIVE">Selective</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6" style={{ display: pOptions === "SEARCH" ? "block" : "none" }}>
                                                        <Form.Group>
                                                            <Form.Label>Ref No<span className='colorThemeRed'>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pRefNo}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchVtSettled(search, {
                                                                    isd: pIsdId,
                                                                    location: pLocRadio === "S" ? pSelectedLocations : pLocRadio === "A" ? 0 : vtLocationValue,
                                                                    group: pIssuerGroup, account: pIssuerAccount, type: settleType
                                                                })}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleRefChange}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Rate<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control type='text' maxLength={Common.rateMaxLength} value={pRate} onChange={e => Common.validateDecValue(e.target.value, setPRate)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6" style={{ display: pOptions === "SELECTIVE" && "none" }}>
                                                        <Form.Group>
                                                            <Form.Label>Value</Form.Label>
                                                            <Form.Control disabled={pOptions === "SEARCH"} type='text' maxLength={10} value={pValue} onChange={e => Common.validateDecValue(e.target.value, setPValue)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addSettlementProduct("P")}>Add</Button>
                                                        &nbsp;
                                                        {/* <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button> */}
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                            </>
                                    }

                                    <Row>
                                        <Table striped responsive bordered>
                                            <thead>
                                                <tr>
                                                    {/* <th>Code</th> */}
                                                    <th>&nbsp;</th>
                                                    <th>Location</th>
                                                    <th>ISD</th>
                                                    <th>Issuer</th>
                                                    <th>Ref no</th>
                                                    <th>Card No</th>
                                                    <th>Sale Rate</th>
                                                    <th>Settle Rate</th>
                                                    <th>Value</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    settlementList.map((item, index) => (
                                                        <tr>
                                                            <td>
                                                                {
                                                                    scrMode === "Q" ? null :
                                                                        <span onClick={() => deleteProduct(item.uniquekey, index)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                            <td>{item.entity_name}</td>
                                                            <td>{item.prd_isd}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.prd_from}</td>
                                                            <td>{item.prd_card_no}</td>
                                                            <td>{item.sale_rate}</td>
                                                            <td>{item.prd_rate}</td>
                                                            <td>{item.prd_deno}</td>
                                                            <td>{item.prd_amount}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                <Tab eventKey="SURRENDER" title="Surrender">
                                    <Row>
                                        <Col>
                                            <h4>Surrender</h4>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    {
                                        scrMode === "Q" ? null :
                                            <>
                                                <Row>
                                                    <Col className='col-md-6 col-12'>
                                                        <LocationSelector onDataFromChild={handleDataFromChild} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={surIsd}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, "")} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleChangeIsd}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Options</Form.Label>
                                                            <Form.Select value={surOptions} onChange={e => handleOptions(e.target.value)}>
                                                                <option value="SEARCH">Search</option>
                                                                {/* <option value="FIFO">FIFO</option> */}
                                                                <option value="SELECTIVE">Selective</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6" style={{ display: surOptions === "SEARCH" ? "block" : "none" }}>
                                                        <Form.Group>
                                                            <Form.Label>Ref No<span className='colorThemeRed'>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={surRefNo}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchVtSettled(search, {
                                                                    isd: surIsdId,
                                                                    location: surLocRadio === "S" ? surSelectedLocations : surLocRadio === "A" ? 0 : evtLocationValue,
                                                                    group: pIssuerGroup, account: pIssuerAccount, type: surrType
                                                                })}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleRefChange}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Rate<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control type='text' maxLength={Common.rateMaxLength} value={surRate} onChange={e => Common.validateDecValue(e.target.value, setSurRate)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6" style={{ display: surOptions === "SELECTIVE" && "none" }}>
                                                        <Form.Group>
                                                            <Form.Label>Value</Form.Label>
                                                            <Form.Control disabled={surOptions === "SEARCH"} type='text' maxLength={10} value={surValue} onChange={e => Common.validateDecValue(e.target.value, setSurValue)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addSurProduct("S")}>Add</Button>
                                                        &nbsp;
                                                        {/* <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button> */}
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                            </>
                                    }

                                    <Row>
                                        <Table striped responsive bordered>
                                            <thead>
                                                <tr>
                                                    {/* <th>Code</th> */}
                                                    <th>&nbsp;</th>
                                                    <th>Location</th>
                                                    <th>ISD</th>
                                                    <th>Issuer</th>
                                                    <th>Ref no</th>
                                                    <th>Card No</th>
                                                    <th>Sale Rate</th>
                                                    <th>Surr Rate</th>
                                                    <th>Value</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    surrenderList.map(item => (
                                                        <tr>
                                                            {/* <td>{item.prd_srno}</td> */}
                                                            <td>
                                                                {
                                                                    scrMode === "Q" ? null :
                                                                        <span onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                            <td>{item.entity_name}</td>
                                                            <td>{item.prd_isd}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.prd_from}</td>
                                                            <td>{item.prd_card_no}</td>
                                                            <td>{item.sale_rate}</td>
                                                            <td>{item.prd_rate}</td>
                                                            <td>{item.prd_deno}</td>
                                                            <td>{item.prd_amount}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                <Tab eventKey="PAYMENT" title="Payment">
                                    <Row>
                                        <Col>
                                            <h4>Payment</h4>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Bank<span className='colorThemeRed'>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={stBank}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'BANK', "0")} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={(value) => setSTBank(value)}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Reference No</Form.Label>
                                                            <Form.Control placeholder='Reference No' maxLength={255} value={pdBankRefNo} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdBankRefNo)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Type</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Cheque</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    scrMode === "Q" ? null :
                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item)}>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                            <td>Bank</td>
                                                            <td>{item.tp_group}</td>
                                                            <td>{item.tp_account}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.tp_amount}</td>
                                                            <td>{item.tp_cheque}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                            </Tabs>
                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <span className="corner-span">{counter}</span>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <Modal size='xl' show={showGvtModal} onHide={() => setShowGvtModal(false)} animation={false} centered>
                <Modal.Footer>
                    <Button variant="outline-success" onClick={addSelectiveGvt}>
                        Save
                    </Button>&nbsp;
                    <Button variant="outline-danger" onClick={() => { setShowGvtModal(false); setSelectiveVTList([]); }}>
                        Cancel
                    </Button>
                </Modal.Footer>
                <Modal.Body>
                    <Table striped responsive bordered>
                        <thead>
                            <tr>
                                <th>
                                    <Form.Check name='ischecked' onChange={e => updateAllCheck(e, "ischecked")} />
                                </th>
                                <th>Code</th>
                                <th>Location</th>
                                <th>Currency</th>
                                <th>Issuer</th>
                                <th>Ref No</th>
                                <th>Card No</th>
                                <th>Sale Rate</th>
                                <th>Rate</th>
                                <th>Value</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                selectiveVTList.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Form.Check name='ischecked' checked={item.ischecked === '1'} onChange={e => updateSelectiveCheck(e, index, "ischecked")} />
                                        </td>
                                        <td>{item.prd_location}</td>
                                        <td>{item.entity_name}</td>
                                        <td>{item.prd_isd}</td>
                                        <td>{item.mvli_ledger_name}</td>
                                        <td>{item.prd_from}</td>
                                        <td>{item.prd_card_no}</td>
                                        <td>{item.sale_rate}</td>
                                        <td>{item.prd_rate}</td>
                                        <td>{item.prd_deno * item.prd_qty}</td>
                                        <td>{item.prd_date_dmy}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-success" onClick={addSelectiveGvt}>
                        Save
                    </Button>&nbsp;
                    <Button variant="outline-danger" onClick={() => { setShowGvtModal(false); setSelectiveVTList([]); }}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
        </div >
    )
}

export default Tran_glvtm_settlement
